import { apiGet } from './client';

export async function fetchVoiceInsights(callSid, env, accountSid) {
  if (!callSid) throw new Error('Missing callSid');
  const params = { callSid, env };
  if (accountSid) params.accountSid = accountSid;
  return apiGet('/voice-insights', { params });
}
